import { ChangeBankAccount } from './ChangeBankAccount'

export default ChangeBankAccount
